module.exports = __webpack_public_path__ + "static/media/bg-top-kn.6d5564dd.svg";